import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { SmoothScroll } from "@/components/common/SmoothScroll";
import { VisitTracker } from "@/components/common/VisitTracker";
import { Nav } from "@/components/common/Nav";
import { Footer } from "@/components/common/Footer";
import Home from "@/pages/Home";
import AppsIndex from "@/pages/AppsIndex";
import AppDetail from "@/pages/AppDetail";
import Support from "@/pages/Support";
import Sources from "@/pages/Sources";
import Legal from "@/pages/Legal";
import Admin from "@/pages/Admin";
import NotFound from "@/pages/NotFound";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    window.__lenis?.scrollTo(0, { immediate: true });
  }, [pathname, hash]);
  return null;
};

const Site = ({ children }) => (
  <>
    <Nav />
    <main>{children}</main>
    <Footer />
  </>
);

export default function App() {
  return (
    <BrowserRouter>
      <SmoothScroll>
        <ScrollToTop />
        <VisitTracker />
        <Routes>
          <Route path="/" element={<Site><Home /></Site>} />
          <Route path="/apps" element={<Site><AppsIndex /></Site>} />
          <Route path="/apps/:slug" element={<Site><AppDetail /></Site>} />
          <Route path="/support" element={<Site><Support /></Site>} />
          <Route path="/sources" element={<Site><Sources /></Site>} />
          <Route path="/privacy" element={<Site><Legal kind="privacy" /></Site>} />
          <Route path="/terms" element={<Site><Legal kind="terms" /></Site>} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<Site><NotFound /></Site>} />
        </Routes>
        <Toaster theme="dark" position="bottom-right" />
      </SmoothScroll>
    </BrowserRouter>
  );
}
